export { default as SelectMaterialsContentSidebar } from './SelectMaterialsContentSidebar';
